/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import MenuIcon from '../MenuIcon'
import styles from './styles'

const MenuOption = ({ selected, disabled, icon, label, theme, onClick }) => (
  <li className={cx(styles.wrapper, selected && styles.selected, disabled && styles.disabled)} onClick={onClick}>
    <MenuIcon icon={icon} theme={theme} />
    <span>{label}</span>
  </li>
)

MenuOption.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.element, PropTypes.shape({})]).isRequired,
  label: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
}

MenuOption.defaultProps = {
  theme: 'primary',
}

export default MenuOption
